import { memo } from 'react';
import { Handle } from 'reactflow';
import "./styles.css";

const SquareNode = memo(({ data }) => {
  return (
    <div className="int__square-node"
      style={{
        backgroundColor: "#E5E5E5",
        padding: "14px"
      }}>
      <Handle
        type="target"
        position="top"
        id="input"
        style={{ width: 0, height: 0, top: -10, border: "none", backgroundColor: "#E5E5E5" }}
      />
      <div
        style={{
          marginTop: "-10px",
          marginLeft: "-90px"
        }}>
        <input className="nodrag" type="text" defaultValue={data.label} disabled style={{ textAlign: "center", width: 170, fontSize: 13 }} />
      </div>
      <Handle
        type="target"
        position="left"
        id="input_left"
        style={{ width: 0, height: 0, border: "none", backgroundColor: "transparent", top: 17, left: -75 }}
      />
      <Handle
        type="source"
        position="right"
        id="output_right"
        style={{ width: 0, height: 0, border: "none", backgroundColor: "transparent", top: 17, right: -65 }}
      />
      <Handle
        type="source"
        position="bottom"
        id="output"
        style={{ width: 0, height: 0, bottom: -10, border: "none", backgroundColor: "#E5E5E5" }}
      />
    </div>
  );
});

SquareNode.displayName = 'SquareNode';
export default SquareNode;
